module.exports = __webpack_public_path__ + "img/DamEnvironmentQuestionselect.e071335c.svg";